<script setup lang="ts">
import { ComboboxGroup, ComboboxLabel } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<{
  asChild?: boolean
  as?: unknown
  heading?: string
}>()
</script>

<template>
  <ComboboxGroup
    v-bind="props"
    :class="cn('text-foreground overflow-hidden p-1', $attrs.class ?? '')"
  >
    <ComboboxLabel v-if="heading" class="text-muted-foreground px-2 py-1.5 text-xs font-medium">
      {{ heading }}
    </ComboboxLabel>
    <slot />
  </ComboboxGroup>
</template>
